export default __webpack_public_path__ + "static/media/profile-settings.30d792c1.svg";